import React from 'react';

const FinancialTable = ({ data }) => {
  const helper = () => ({
    formatNumber: (value) => Number(value).toFixed(2)
  });

  const getRowTotal = (monthlyData = []) => {
    return monthlyData.reduce((sum, m) => sum + (parseFloat(m?.value) || 0), 0);
  };

  return (
    <div className="financial-table">
      {data.map((item, index) => (
        <div key={index}>
          <div className={`row  ${item.name === "Data" ? "" : "main-row"}`} >
            <div className="col-2   d-flex justify-content-start">
              {item.name === "Data" ? <></> : <p className="m-0 fw-bold">{item.name} :</p>}

            </div>
            <div className="col-9  ">
              <div className="row 1">
                {item.monthlyData.map(monthData => (
                  <>
                    {item.name === "Data" ?
                      <div key={monthData.month} className="col-1 month-input">
                        <p className='text-center mb-0 fw-bold'>{monthData.value}</p>
                      </div>
                      :
                      <div key={monthData.month} className="col-1 month-input pr-1">
                        <input
                          type="number"
                          className="form-control form-control-sm text-right fw-bold text-size14"
                          disabled
                          value={helper().formatNumber(monthData.value)}
                        />
                      </div>}

                  </>

                ))}
              </div>
            </div>
            {item.name === 'Data' ? (
              <div className="col-1 month-input">
                <p className='text-center mb-0 fw-bold'>Total</p>
              </div>
            ) : (
              <div className="col-1 month-input pr-1">
                <input
                  type="number"
                  className="form-control form-control-sm text-right fw-bold text-size14"
                  disabled
                  value={helper().formatNumber(getRowTotal(item.monthlyData))}
                />
              </div>
            )}
          </div>
          {item.subItems.length > 0 && (
            <div className="sub-items">
              {item.subItems.map((subItem, subIndex) => (
                <div key={subIndex} className="row sub-row">
                  <div className="col-2   d-flex justify-content-start">
                    <p className="m-0 font-italic">{subItem.name}</p>
                  </div>
                  <div className="col-9  d-flex justify-content-start">
                    <div className="row">
                      {subItem.monthlyData.map(monthData => (
                        <div key={monthData.month} className="col-1 month-input pr-1">
                          <input
                            type="number"
                            className="form-control form-control-sm text-right"
                            disabled
                            value={helper().formatNumber(monthData.value)}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-1 month-input pr-1">
                    <input
                      type="number"
                      className="form-control form-control-sm text-right"
                      disabled
                      value={helper().formatNumber(getRowTotal(subItem.monthlyData))}
                    />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FinancialTable;
